import { render, staticRenderFns } from "./derate-manage.vue?vue&type=template&id=393d5598&scoped=true"
import script from "./derate-manage.vue?vue&type=script&lang=ts"
export * from "./derate-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393d5598",
  null
  
)

export default component.exports